































import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import { EmptyState, FullPage, MobileLayout } from '@/layouts/components'

@Component({
  components: {
    EmptyState,
    FullPage,
    MobileLayout
  }
})
export default class NotFound extends Vue {
  @Getter('auth/isAuthenticated')
  readonly isAuthenticated!: boolean
}
